module.exports = __webpack_public_path__ + "static/img/json-ext-thumbnail.5e0f93da.svg";